/**
 * Supported locales for Farmly Public English v1.
 *
 * Default: `sv`. English is opt-in via the `?lang=en` query parameter
 * or the LocaleSwitcher in the public header.
 *
 * See `docs/SoT/localization.md` for the canonical decisions:
 *   - Swedish is the default and the source-of-truth language.
 *   - English is currently exposed only on public surfaces.
 *   - Routing is `?lang=en` in v1. Path-based `/en/...` is reserved
 *     for a later phase (do not add it ad-hoc).
 *   - Missing translations fall back to the Swedish source string.
 */

export const SUPPORTED_LOCALES = ["sv", "en"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "sv";

/** Open Graph locale tags per supported locale. */
export const OG_LOCALE: Record<Locale, string> = {
  sv: "sv_SE",
  en: "en_US",
};

/** HTML `lang` attribute values per supported locale. */
export const HTML_LANG: Record<Locale, string> = {
  sv: "sv",
  en: "en",
};

export function isSupportedLocale(value: unknown): value is Locale {
  return typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
